import { Box, Flex, Grid, GridItem, Text, Tooltip } from '@chakra-ui/react';
import ComposeEmail from 'src/components/EmailModule';
import SubmissionInfoWithAuthors from '../SubmissionInfoWithAuthors';
import Loading from '../../../../pages/Status/Loading';
import { EmailTemplateDoc } from '@publishing-engine/domain/models/email-templates';
import { IDomainCommandType } from '@publishing-engine/domain/actions/v1/commands';
import { ButtonText } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  closeModal: () => void;
  adHocEmail?: boolean;
  removeBrowseTemplates?: boolean;
  emails?: string[];
  emailTemplates: EmailTemplateDoc[] | undefined;
  attachments?: any[];
  isLoadingTemplates: boolean;
  commandName: IDomainCommandType;
}

const RIWithSubmissionDetails = ({
  closeModal,
  adHocEmail = false,
  removeBrowseTemplates = false,
  emails = [],
  emailTemplates,
  attachments = [],
  isLoadingTemplates
}: Props) => {
  if (isLoadingTemplates) return <Loading />;

  return (
    <Box
      backgroundColor="surfaceTertiaryFill"
      paddingX={4}
      paddingY={2}
      minH="100vh"
    >
      <Grid templateColumns="repeat(12, 1fr)" gap={2}>
        <GridItem colSpan={12}>
          <ButtonText variant="primary" onClick={closeModal}>
            <FontAwesomeIcon icon={faArrowLeft} /> Back
          </ButtonText>
          <Flex alignItems="center">
            <Text textStyle="headingSection">
              {adHocEmail ? 'Compose Email' : 'Send Email Notification'}
            </Text>
            <Tooltip
              hasArrow
              shouldWrapChildren
              placement="top"
              label={
                <Text textStyle="textContext">
                  {adHocEmail
                    ? 'Compose your email, or select a template to pre-fill the subject and body. Submission details will be included automatically'
                    : 'Use the default template to invite reviewers, or customize the invitation’s subject, personal, and journal information. Submission details are always included automatically'}
                </Text>
              }
              borderRadius={4}
              data-cy="info-tooltip"
            >
              <ButtonText>
                <FontAwesomeIcon icon={faInfoCircle} />
              </ButtonText>
            </Tooltip>
          </Flex>
        </GridItem>

        <GridItem colSpan={12}>
          <SubmissionInfoWithAuthors />
        </GridItem>
        <GridItem colSpan={12}>
          <ComposeEmail
            emailTemplates={emailTemplates}
            adHocEmail={adHocEmail}
            removeBrowseTemplates={removeBrowseTemplates}
            emails={emails}
            attachments={attachments}
          />
        </GridItem>
      </Grid>
    </Box>
  );
};

export default RIWithSubmissionDetails;
